import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import { BrandLoader, useDelayedFlag } from '../ui';
import { useAuth } from '../../contexts/AuthContext';
import { sbg } from '../../theme/sbgTokens';

/** Fast session checks show a blank canvas; the brand loader only appears when boot takes over a second (book §11.15). */
const LOADER_DELAY_MS = 1000;

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { session, loading } = useAuth();
  const location = useLocation();
  const showLoader = useDelayedFlag(loading, LOADER_DELAY_MS);

  if (loading) {
    return (
      <Box
        aria-busy="true"
        sx={{
          minHeight: '100vh',
          '@supports (height: 100dvh)': { minHeight: '100dvh' },
          display: 'grid',
          placeItems: 'center',
          bgcolor: sbg.bg.canvas,
        }}
      >
        {showLoader && <BrandLoader label="Opening your workspace…" />}
      </Box>
    );
  }

  if (!session) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <>{children}</>;
};

export default RequireAuth;
